// Reusable Kiss lips image icon
export const KissIcon = ({ className = "w-5 h-5", style }) => (
  <img src="/kiss.png" alt="💋" className={className} style={{ objectFit: 'contain', ...style }} />
);

// BIZ💋U logo using real assets
export const BizouLogo = ({ size = "md", className = "" }) => {
  const config = {
    sm: { imgH: "h-4", textSize: "text-sm" },
    md: { imgH: "h-5", textSize: "text-lg" },
    lg: { imgH: "h-7", textSize: "text-2xl" },
    xl: { imgH: "h-10", textSize: "text-3xl" },
  };
  const c = config[size] || config.md;
  
  return (
    <span className={`inline-flex items-center ${className}`}>
      <img src="/bizou-logo.png" alt="BIZOU" className={c.imgH} style={{ objectFit: 'contain' }} />
      <span className={`text-[#1C1917] font-bold ${c.textSize}`} style={{ fontFamily: "'Manrope', sans-serif" }}>.me</span>
    </span>
  );
};

export default BizouLogo;
